import { ProjectId, DocumentId, DateType, User } from 'api/models';
import { HttpClient } from '../http-client';

export enum ApprovalStatus {
  ApprovalRequested = 'APPROVAL_REQUESTED',
  ChangeRequested = 'CHANGE_REQUESTED',
  Approved = 'APPROVED',
}

export interface ApprovalRequestTo {
  userId: number;
  approvalStatus: ApprovalStatus;
  updatedAt?: number;
  // TODO: @asimkt Should only have updatedAt. remove updateAt once api fix this.
  updateAt?: number;
}

export interface ApprovalComment {
  commentId: number;
  content?: string | null;
  createdBy: number;
  createdAt: number;
  private: boolean;
}

export interface Approval {
  approvalId: number;
  documentId?: number;
  dueDate?: DateType | null;
  requestBy: User;
  requestTo: Array<ApprovalRequestTo>;
  comments?: Array<ApprovalComment>;
  private: boolean;
  createdAt: number;
}

export type CreateApprovalPayload = Pick<
  Approval,
  'private' | 'requestBy' | 'requestTo' | 'dueDate'
> & {
  comment?: Pick<ApprovalComment, 'content'>;
};

export type UpdateApprovalPayload = Pick<
  CreateApprovalPayload,
  'requestTo' | 'comment'
>;

class DocumentApprovalHttpClient extends HttpClient {
  public async getApprovalList(
    [, projectId]: ProjectId,
    [, documentId]: DocumentId,
  ): Promise<Approval[]> {
    return this.get<Approval[]>(
      `/projects/${projectId}/documents/${documentId}/approvals`,
    );
  }

  public async updateApproval(
    [, projectId]: ProjectId,
    [, documentId]: DocumentId,
    approvalId,
    payload: UpdateApprovalPayload,
  ): Promise<Approval> {
    return this.put(
      `projects/${projectId}/documents/${documentId}/approvals/${approvalId}`,
      payload,
    );
  }

  public async createApproval(
    [, projectId]: ProjectId,
    [, documentId]: DocumentId,
    payload: CreateApprovalPayload,
  ): Promise<Approval> {
    return this.post(
      `projects/${projectId}/documents/${documentId}/approvals`,
      payload,
    );
  }

  public async deleteApproval(
    [, projectId]: ProjectId,
    [, documentId]: DocumentId,
    approvalId,
  ) {
    return this.delete(
      `projects/${projectId}/documents/${documentId}/approvals/${approvalId}`,
    );
  }
}

export const DocumentApprovalAPI = new DocumentApprovalHttpClient();
